export const ORDERED_LIST_TAG_NAME = 'ol';
